import React, { Component, useEffect, useState } from 'react';
import Age from './general/age.jsx'
import Queer from './general/queer.jsx';
import Language from './general/language.jsx';
import Knowledge from './general/knowledge.jsx';
import { ref, get, child, set } from "firebase/database";
import { db } from "../firebase.js";
import * as d3 from "d3";


function General (props) {

    const setStep = props.setStep,
        participant = props.participant,
        session = props.session;

    const [age, setAge] = useState()
    const [queer, setQueer] = useState()
    const [language, setLanguage] = useState()
    const [knowledge, setKnowledge] = useState()

    const complete = language && age && knowledge && queer

    function submitGeneral () {

        const today = new Date();

        const response = {
            participant: participant,
            general: {
                age: age,
                queer: queer,
                language: language,
                knowledge: knowledge
            },
            test: [],
            date: today.getDate() + '/' + (today.getMonth()+1) + '/' + today.getFullYear(),
            hour: today.getHours() + ':' + today.getMinutes()
        }

        const dataRef = ref(db, 'session_' + session + '/' + participant);
        set(dataRef, response)

        d3.select('.panel').style('opacity', 1).transition().duration(500).style('opacity', 0)
        setTimeout(() => setStep(3), 500)
    }

    useEffect(() => {
        d3.select('.panel').transition().duration(1000).style('opacity', 1);
    })

    return (
        <div className="panel" style={{opacity: 0, maxWidth: '95%', width: '55em'}}>
            <div className="panel_content">
                <h1>General information</h1>
                <form 
                    id="general_form"
                    action="/submit-survey" 
                    method="post" 
                    style={{
                        display: 'flex', 
                        gap: '0.5em', 
                        marginBottom: '0.75em',
                        justifyContent: 'space-between'
                    }}
                >
                    <Language
                        language = {language}
                        setLanguage = {setLanguage}
                    />
                    <Age
                        age = {age}
                        setAge = {setAge}
                    />
                    <Queer
                        queer = {queer}
                        setQueer = {setQueer}
                    />
                    <Knowledge
                        knowledge = {knowledge}
                        setKnowledge = {setKnowledge}
                    />
                </form>
                <button 
                    className={complete ? "button_primary" : "button_primary button_inactive"}
                    onClick={() => {submitGeneral()}}>
                        Go to the next phase
                </button>
            </div>
            <div className="panel_footer" style={{backgroundImage:'url("./img/PNRR_loghi.png'}}></div>
        </div>
    )
}

export default General;